// Czas po jakim następuje domyślny reject - zabezpieczenie przed nieodpowiadaniem objektu wrapee
const TIMEOUT = 3000;

type MobileMetrics = {
	appVersion: string;
	deviceType: string;
	appType: string;
	deviceInfo: {
		phoneModel: string;
	}
};

enum NavigationMobileEvent {
	afterPlaceOrder = 'rfp-order-place',
	addNewOder = 'add-new-order',
	finishAutentiProgress = 'finishAutentiProgress',
	clickLoginBtn = 'click-login-btn',
}

enum AnalyticsMobileEvent {
	clickAddRequest = 'click_addRequest',
	stopModalFormOEX = 'stop_modalForm_oex',
}

enum ClosePageMobileEvent {
	rfpModal = 'rfp-modal',
	oexRfpModal = 'oex-rfp-modal',
}

enum WrapeeMethod {
	getPermissionStatus = 'getPermissionStatus',
	requestPermissionStatus = 'requestPermissionStatus',
	openAppSettings = 'openAppSettings',
	getMobileMetrics = 'getMobileMetrics',
	openNewWindow = 'openNewWindow',
	openNewWindowExternal = 'openNewWindowExternal',
	showInAppReviewDialog = 'showInAppReviewDialog',
	onPageClose = 'onPageClose',
	share = 'share',
	onNavigationEvent = 'onNavigationEvent',
	onAnalyticsEvent = 'onAnalyticsEvent',
}

type InvokeWrapeeMethod = {
	(methodName: 'getPermissionStatus', permissionType: string): Promise<string>;
	(methodName: 'requestPermissionStatus', permissionType: string): Promise<string>;
	(methodName: 'openAppSettings', permissionType: string): Promise<string>;
	(methodName: 'getMobileMetrics'): Promise<MobileMetrics>;
	(methodName: 'openNewWindow', href: string): Promise<Window>;
	(methodName: 'openNewWindowExternal', href: string): Promise<Window>;
	(methodName: 'showInAppReviewDialog'): Promise<Window>;
	(methodName: 'onPageClose', event: ClosePageMobileEvent): Promise<string>;
	(methodName: 'share', text: string): Promise<void>;
	(methodName: 'onNavigationEvent', event: NavigationMobileEvent): Promise<void>;
	(methodName: 'onAnalyticsEvent', event: AnalyticsMobileEvent): Promise<void>;
	(methodName: 'loginGoogle'): Promise<string>;
}

class WrapeeNotSupportedError extends Error {
	constructor() {
		super('Wrapee is not supported');
	}
}

const invokeWrapeeMethod = ((methodName, ...args: string[]) => {
	const { wrapee } = window.top;
	if (typeof wrapee !== 'object' || wrapee === null) {
		return Promise.reject(new WrapeeNotSupportedError());
	}

	if (typeof wrapee[methodName] !== 'function') {
		return Promise.reject(new Error(`Method ${methodName} is not a function`));
	}

	const timeoutPromise = new Promise<never>((_, timeoutReject) => {
		setTimeout(() => {
			timeoutReject(new Error(`Promise from ${methodName} method was rejected after ${TIMEOUT}ms`));
		}, TIMEOUT);
	});

	const methodPromise = Promise.resolve((wrapee[methodName](...args)));

	console.log(`${methodName} method was triggered`);

	return Promise.race([timeoutPromise, methodPromise]);
}) as InvokeWrapeeMethod;

export {
	invokeWrapeeMethod,
	WrapeeNotSupportedError,
	WrapeeMethod,
	ClosePageMobileEvent,
	NavigationMobileEvent,
	AnalyticsMobileEvent,
};
